// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("NpcSpawnerUpdate", {
  spawnerId: __t.u64(),
  templateKey: __t.string(),
  respawnTicks: __t.u32(),
  wanderTiles: __t.u32(),
  hpOverride: __t.u32(),
  dmgOverride: __t.u32(),
});


